import React from "react";
import { MessageStatus } from "../../../../constant/Types";
import VoicePlayer from "./VoicePlayer";
import { getHoursMinutesTime } from "../../../../constant/helper";
import AvatarPreview from "../../../profile/components/AvatarPreview";

const VoiceMessageLawyer = ({
  time,
  data,
  status,
  meta,
  messageCancel,
  messageRetry,
  waveSurfer,
  pauseAll,
}) => {
  let statusResult =
    status === MessageStatus.sending || status === MessageStatus.failed
      ? status
      : "DONE";

  function cancel() {
    messageCancel(meta);
  }

  function retry() {
    messageRetry(meta.id);
  }

  return (
    <div
      className={`msg msg-voice  ${
        statusResult === "DONE" ? "msg-voice-done" : ""
      }`}
    >
      <div className="msg-wrapper">
        <div className={"msg-avatar-bg"}>
          <div className={"msg-avatar-holder"}>
            <AvatarPreview
              isSvg={false}
              src={meta.subscriber.extraInfo?.avatarImageUrl || "LAWONE"}

              // profile.data.extraInfo?.avatarImageUrl ||
            />{" "}
          </div>
        </div>
        <VoicePlayer
          url={data && data.link !== "" ? data.link : ""}
          data={meta && meta.temp ? meta.temp : ""}
          status={status}
          pauseAll={pauseAll}
          key={`voice-${
            meta && meta.id ? meta.id : time
          }-${new Date().getTime()}`}
          keyName={`voice-${
            meta && meta.id ? meta.id : time
          }-${new Date().getTime()}`}
          waveSurfer={waveSurfer}
          id={meta.id}
          cancel={cancel}
          retry={retry}
        />
        <div className={"msg-time"}> {time && getHoursMinutesTime(time)} </div>
      </div>
    </div>
  );
};

export default VoiceMessageLawyer;
